import { http } from 'connex-cds';

export default {
  listFeatureFlags: ({ entityRef, flagName }) =>
    http?.get?.({
      apiName: 'mt',
      path: `/${entityRef}/feature-flags`,
      queryParams: { flagName },
    }),
};
